import type { TextFieldProps } from '../components/molecules/TextField';

export type PickerFieldProps = Pick<TextFieldProps, 'helperText' | 'error' | 'required' | 'size' | 'fullWidth'>;

export function pickerFieldSlotProps<OwnerState, SlotProps extends object>(
  slotProps: SlotProps | ((ownerState: OwnerState) => SlotProps) | undefined,
  fieldProps: PickerFieldProps,
) {
  const givenFieldProps = Object.fromEntries(Object.entries(fieldProps).filter(([, value]) => value !== undefined));

  return (ownerState: OwnerState) => ({
    ...(typeof slotProps === 'function' ? slotProps(ownerState) : slotProps),
    ...givenFieldProps,
  });
}
